// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryLinks_root__Z1vFb"};